(function installChameleonVideoLibrary(global) {
  'use strict';

  const thresholds = [25, 50, 75];

  const bind = root => {
    if (!root || root.dataset.videoBound === 'true') return;
    const video = root.querySelector('[data-cha-video]');
    if (!video) return;
    root.dataset.videoBound = 'true';

    const videoId = root.dataset.videoId || 'unknown';
    const videoTitle = root.dataset.videoTitle || videoId;
    const surface = root.dataset.videoSurface || 'website';
    const reported = new Set();
    let started = false;

    video.addEventListener('play', () => {
      if (started) return;
      started = true;
      global.ChameleonPulse?.videoStarted?.(videoId, videoTitle, surface);
    });

    video.addEventListener('timeupdate', () => {
      if (!Number.isFinite(video.duration) || video.duration <= 0) return;
      const percent = Math.floor((video.currentTime / video.duration) * 100);
      thresholds.forEach(threshold => {
        if (percent >= threshold && !reported.has(threshold)) {
          reported.add(threshold);
          global.ChameleonPulse?.videoProgress?.(videoId, videoTitle, surface, threshold);
        }
      });
    });

    video.addEventListener('ended', () => {
      global.ChameleonPulse?.videoCompleted?.(videoId, videoTitle, surface);
    });

    root.querySelector('[data-cha-video-cta]')?.addEventListener('click', () => {
      global.ChameleonPulse?.videoCtaClicked?.(videoId, videoTitle, surface);
    });
  };

  const bindAll = scope => (scope || document).querySelectorAll('[data-cha-video-feature]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindAll());
  else bindAll();
  document.addEventListener('shopify:section:load', event => bindAll(event.target));
}(window));
